<template>
  <AppValidation
    :rules="rules"
    :name="$attrs.name || $attrs.label"
    v-slot="{ errors }"
  >
    <v-autocomplete
      v-model="innerValue"
      v-bind="$attrs"
      :error-messages="errors"
    >
      <template v-if="$attrs.customLabel" v-slot:item="$attrs">
        <span class="caption mr-1">{{ $attrs.item.id }}</span> {{ $attrs.item.name }}
      </template>
    </v-autocomplete>
  </AppValidation>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    'AppValidation': ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    value: {
      type: null
    },
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
